import { Pagination, PaginationProps, RenderDataWithFallback, RenderDataWithFallbackProps } from '@anytag/shared-atoms';

export interface ListWithPaginationProps extends RenderDataWithFallbackProps {
  pagination?: PaginationProps;
  className?: string;
}
export const ListWithPagination = ({ pagination, className, ...props }: ListWithPaginationProps) => (
  <div className={className}>
    <RenderDataWithFallback {...props} />
    {!props.loading && !!pagination ? <Pagination className="border-t-border px-4 py-2" {...pagination} /> : null}
  </div>
);
